import { render } from "./RntrcOutroServico.vue?vue&type=template&id=5d7489e4&scoped=true"
import script from "./RntrcOutroServico.vue?vue&type=script&lang=ts"
export * from "./RntrcOutroServico.vue?vue&type=script&lang=ts"

import "./RntrcOutroServico.vue?vue&type=style&index=0&id=5d7489e4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d7489e4"

export default script